import { render, staticRenderFns } from "./dashboardInfoCard.vue?vue&type=template&id=ce917440&scoped=true"
import script from "./dashboardInfoCard.vue?vue&type=script&lang=js"
export * from "./dashboardInfoCard.vue?vue&type=script&lang=js"
import style0 from "./dashboardInfoCard.vue?vue&type=style&index=0&id=ce917440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce917440",
  null
  
)

export default component.exports